const config = {
  colors: [
    "#FFDA45",
    "#FE9855",
    "#64C358",
    "#549BEC",
    "#BF59FF",
    "#ECA155",
    "#A68AFC",
    "#EC5555",
  ],
  padding: { top: 16, right: 12, bottom: 28, left: 40 },
  axis: {
    color: "#9ca3af",
    labelColor: "#474747",
    edgePadding: 0,
    y: {
      gridLines: 5,
      clampMinZero: false,
      //step: 100
    },
  },
  grid: {
    color: "#e5e7eb",
    dasharray: "3 3",
    strokeWidth: 1,
    horizontal: true,
    vertical: true,
    background: "transparent",
  },
  legend: {
    show: true,
    mode: "inline",
    maxHeight: 160,
    searchPlaceholder: "Search",
  },
  showLabels: {
    show: false,
    valueDisplay: "value", // value | percentage | value_percentage
    color: "#111827",
    fontSize: 10,
    strategy: "hide",
    minGap: 12,
    maxStack: 3,
    stroke: "#ffffff",
    strokeWidth: 2,
  },
  background: "transparent",
  animations: { enabled: true, duration: 600 },
  decimate: { enabled: true, targetPointsPerPixel: 1.0, minPoints: 200 },
};

const lineConfig = {
  stroke: { width: 1, curve: "straight" },
  fill: { type: "none" },
  markers: { size: 2 },
};

const areaConfig = {
  stroke: { width: 1, curve: "straight" },
  fill: { type: "solid" },
  markers: { size: 2 },
};

const columnConfig = {
  bar: {
    gap: 5,
    radius: 2,
    //groupGap: 20,
    fixedWidth: 10,
  },
};

const barConfig = {
  bar: { gap: 5, radius: 2, groupGap: 20, fixedHeight: 10 },
};

const pieConfig = {
  pie: {
    donutRatio: 0,
    circle: "full",
    orientation: "bottom",
    gap: 0,
    infoSection: {
      show: false,
      search: false,
      searchPlaceholder: "Search",
      side: "right", //"right" , "left" , "auto"
      align: "center", //top, bottom, center
      valueDisplay: "value", // value | percentage | value_percentage
      width: 200,
      height: 40,
      total: false,
      totalLabel: "Total",
    },
  },
};

const donutConfig = {
  pie: {
    donutRatio: 0.6,
    circle: "full",
    orientation: "bottom",
    gap: 0,
    infoSection: {
      show: false,
      search: false,
      searchPlaceholder: "Search",
      side: "auto", //"right" , "left" , "auto"
      align: "center", //top, bottom, center
      valueDisplay: "value", // value | percentage | value_percentage
      width: 200,
      height: 40,
      total: true,
      totalLabel: "Total",
    },
  },
};

const listConfig = {
  list: {
    valueColor: "#FE9855",
    borderColor: "#e5e7eb",
    rounded: 8,
    item: { padding: 10, gap: 8 },
    total: false,
    totalLabel: "Total",
  },
};

export default config;
export {
  config,
  lineConfig,
  areaConfig,
  columnConfig,
  barConfig,
  pieConfig,
  donutConfig,
  listConfig,
};
